/* worldie — adventure club "already signed up" state (WOR-145).
   Loaded on every page by snippets/ac-state.liquid, which explains the flag
   and the swap. This file:

   1. Listens for Klaviyo's `klaviyoForms` window event. On `submit` from an
      allowlisted form (Ryan's popup SBUCy9) - which Klaviyo fires only once
      it accepted the subscribe, with the address in detail.metaData.$email:
        - sets localStorage `wd_ac_in` = now (a timestamp, never the address);
        - adds `wd-ac-in` to <html>, which swaps the page's sign-up blocks to
          "you're in ..." + sign in, in place;
        - POSTs { email } to /a/club/list-signup (the club backend through
          the App Proxy). The body is the only place the address goes; the
          backend copies the sign-up into Shopify after Klaviyo confirms it,
          and answers the same 202 whatever happened;
        - sends `ac_list_signup { placement: 'popup' }` through
          window.WorldieTrack (snippets/wd-track: Shopify.analytics.publish
          + the Google channel's gtag, queued until gtag exists), like the
          site's own form. Publish alone never reached GA4: no pixel
          forwards custom events (WOR-150). No address in the payload.
   2. Exposes WorldieAcState.mark() so assets/ac-signup.js can set the same
      flag after our own form posts.
   3. Sign-in pre-fill (Jason 2026-10-20): no form can sign anyone in, so
      the first visit to a club page goes through Shopify's sign-in. The
      address the parent just joined with (popup or our own form) is kept
      in localStorage `wd_ac_email` ({ e, at }) on that browser only, for 30
      days, and added as `login_hint` to the site's sign-in links
      (/customer_authentication/login), which Shopify's sign-in page uses
      to fill its email field. Nothing else reads it and it is never sent
      anywhere but that sign-in link. Dropped the moment the browser is
      signed in (html[data-wd-signed-in], set by snippets/ac-state.liquid).

   Klaviyo's onsite script also posts the step-2 (SMS) submit as its own
   event; only `submit` counts here. */
(function () {
  'use strict';
  if (window.WorldieAcState) return;

  var KEY = 'wd_ac_in';
  var EMAIL_KEY = 'wd_ac_email';
  var EMAIL_DAYS = 30;
  var LOGIN_PATH = '/customer_authentication/login';
  var FORMS = { SBUCy9: true };
  var EVENT = 'ac_list_signup';
  var ENDPOINT = '/a/club/list-signup';

  function mark() {
    try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    document.documentElement.classList.add('wd-ac-in');
  }

  function rememberEmail(email) {
    if (typeof email !== 'string') return;
    email = email.trim();
    if (email.indexOf('@') < 1 || email.length > 254) return;
    try { window.localStorage.setItem(EMAIL_KEY, JSON.stringify({ e: email, at: Date.now() })); } catch (e) {}
    fillSignInLinks();
  }

  function signedIn() {
    return document.documentElement.hasAttribute('data-wd-signed-in');
  }

  // the address to pre-fill, or '' (none kept, too old, or this browser is signed in)
  function hint() {
    try {
      if (signedIn()) { window.localStorage.removeItem(EMAIL_KEY); return ''; }
      var v = JSON.parse(window.localStorage.getItem(EMAIL_KEY) || 'null');
      if (!v || typeof v.e !== 'string' || !(v.at > 0)) return '';
      if (Date.now() - v.at > EMAIL_DAYS * 86400000) { window.localStorage.removeItem(EMAIL_KEY); return ''; }
      return v.e;
    } catch (e) {
      return '';
    }
  }

  // a sign-in URL with login_hint added (unchanged when there is nothing to add)
  function withHint(url) {
    var email = hint();
    if (!email || typeof url !== 'string' || url.indexOf(LOGIN_PATH) === -1 || /[?&]login_hint=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'login_hint=' + encodeURIComponent(email);
  }

  // every sign-in link on the page, and the club gate's redirect target (club.js reads
  // data-club-gate-url on DOMContentLoaded; this deferred script runs before that)
  function fillSignInLinks() {
    if (!hint()) return;
    try {
      document.querySelectorAll('a[href*="' + LOGIN_PATH + '"]').forEach(function (a) {
        var next = withHint(a.getAttribute('href'));
        if (next !== a.getAttribute('href')) a.setAttribute('href', next);
      });
      document.querySelectorAll('[data-club-gate-url*="' + LOGIN_PATH + '"]').forEach(function (el) {
        var next = withHint(el.getAttribute('data-club-gate-url'));
        if (next !== el.getAttribute('data-club-gate-url')) el.setAttribute('data-club-gate-url', next);
      });
    } catch (e) {}
  }

  function send(payload) {
    try {
      if (window.WorldieTrack && typeof window.WorldieTrack.emit === 'function') {
        window.WorldieTrack.emit(EVENT, payload);
      }
    } catch (e) {}
  }

  function report(email) {
    try {
      window.fetch(ENDPOINT, {
        method: 'POST',
        keepalive: true,
        credentials: 'same-origin',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ email: email })
      }).catch(function () {});
    } catch (e) {}
  }

  var seen = {};
  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (!d || d.type !== 'submit' || !FORMS[d.formId]) return;
    var email = d.metaData && d.metaData.$email;
    if (typeof email !== 'string' || email.indexOf('@') < 1) return;
    // one report per form per page view (Klaviyo may re-dispatch)
    if (seen[d.formId]) return;
    seen[d.formId] = true;
    mark();
    rememberEmail(email);
    report(email.trim());
    send({ placement: 'popup' });
  });

  // the parsed page is here (deferred): fill the links now, before club.js's gate runs
  hint();
  fillSignInLinks();

  window.WorldieAcState = { mark: mark, key: KEY, rememberEmail: rememberEmail, withHint: withHint };
})();
